module.exports = __webpack_public_path__ + "img/safe-box.1a9ead0d.svg";